<template>
  <editor v-bind="$attrs"  :init="{plugins: 'wordcount'}" data-cy="editor" />
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
export default {
  components: {
    editor: Editor
  },
  props: {
    value: null
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
<style>
  .tox-notifications-container {
    display: none !important;
  }
</style>
